import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall, FrappeDB } from 'frappe-js-sdk';
import { AppConstant } from '../app.constant';

@Injectable({
    providedIn: 'root'
})
export class reconciliationService {
    private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    private db:FrappeDB;
    constructor() {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
        this.db=this.frappe.db()
    }

    public get_reconciliation(): Promise<any> {
        return this.frappe.call().get('vendor_portal.rest.get_reconciliation');
    }

    public get_reconciliations(page:number): Promise<any> {
        return this.frappe.call().get('vendor_portal.rest.get_reconciliation_lists',{ page });
    }

    public getReconciliationLists(data:any): Promise<any> {
        return this.frappeCall.get('vendor_portal.rest.get_pageable_reconciliation',{ data })
    }
    

}
